import { PluginKey } from "@tiptap/pm/state";
const COLLAPSIBLE_LIST_SETTINGS_MODAL_ID = "COLLAPSIBLE_LIST.settings";
const collapsibleStateManagerPlugin = new PluginKey("collapsibleStateManager");
export {
  COLLAPSIBLE_LIST_SETTINGS_MODAL_ID,
  collapsibleStateManagerPlugin
};
//# sourceMappingURL=consts.js.map
